import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { BulkCampaignType } from '../../types/api/graphql';

export const useBulkTypeValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      [
        BulkCampaignType.Text,
        BulkCampaignType.BulkInvite,
        BulkCampaignType.PlanAppointment,
      ].map(option => ({
        key: option,
        title: intl.formatMessage({
          id: `common.bulk-type.${kebabCase(option)}`,
        }),
      })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
